import React, { Component } from 'react'
import './index.less'

export default class extends Component {
  render() {
    const { titleBg, topBg, centerBg, bottomBg, bgColor1, bgColor2, extraRewardImage, extraRewardName, extraRewardDay, extraRewardProgress, exRw, extraRewardProgressVal } = this.props
    return (
      <div className="extra-reward-container">
        <div className="e-r-banner-title" style={{ backgroundImage: `url(${titleBg})` }}>
          Extra Reward
        </div>
        <div className="e-r-title" style={{ backgroundImage: `url(${topBg})` }}></div>
        <div className="e-r-main" style={{ backgroundImage: `url(${centerBg})` }}>
          <div className="e-r-left">
            <div className="title">{exRw(extraRewardProgress)}</div>
            <div className="num">
              <span className='current'>{extraRewardProgressVal}</span>
              /
              <span className='target'>{extraRewardProgress}</span>
            </div>
            <div className="prog">
              <div className="outer" style={{ background: `linear-gradient(to right, ${bgColor1}, ${bgColor2}` }}>
                <div
                  style={{ transform: `translateX(${-100 + ((extraRewardProgressVal / extraRewardProgress) * 100)}%)` }}
                  className="done-prog"></div>
              </div>
            </div>
          </div>
          <div className="e-r-right">
            <div className="pic">
              <img src={extraRewardImage} alt="" />
            </div>
            <div className="name">
              <span className='desc'>{extraRewardName}</span>
              <span className='day'>({extraRewardDay}D)</span>
            </div>
          </div>
        </div>
        <div className="e-r-bottom" style={{ backgroundImage: `url(${bottomBg})` }}></div>
      </div >
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/nationalTemplate/ExtraReward/index.js